import React from "react";
import { AlertTriangle, RefreshCw, Home } from "lucide-react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an unhandled rendering error:", error, errorInfo);
    this.setState({ errorInfo });
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[400px] flex items-center justify-center p-6 bg-[var(--surface-base,#0B0F17)] text-[var(--text,#F1F5F9)] font-sans">
          <div className="max-w-xl w-full p-6 sm:p-8 rounded-2xl bg-[var(--surface,#131825)] border border-red-500/30 shadow-2xl space-y-4">
            <div className="flex items-center gap-3">
              <div className="p-3 rounded-xl bg-red-500/15 text-red-400 shrink-0">
                <AlertTriangle size={24} />
              </div>
              <div>
                <h2 className="text-lg font-bold text-[var(--text)]">Something went wrong</h2>
                <p className="text-xs text-[var(--muted,#94A3B8)]">An unexpected error occurred while rendering this view.</p>
              </div>
            </div>

            {this.state.error && (
              <div className="p-3.5 rounded-xl bg-black/40 border border-red-500/20 text-xs font-mono text-red-300 break-words whitespace-pre-wrap overflow-x-auto max-h-48">
                {this.state.error.toString()}
                {this.state.errorInfo?.componentStack && (
                  <div className="mt-2 text-[10px] text-slate-400">
                    {this.state.errorInfo.componentStack}
                  </div>
                )}
              </div>
            )}

            <div className="flex items-center gap-3 pt-2">
              <button
                type="button"
                onClick={this.handleGoHome}
                className="btn-primary text-xs py-2 px-4 flex items-center gap-1.5"
              >
                <Home size={14} />
                <span>Return to Home</span>
              </button>
              <button
                type="button"
                onClick={this.handleReload}
                className="btn-secondary text-xs py-2 px-4 flex items-center gap-1.5"
              >
                <RefreshCw size={14} />
                <span>Reload Page</span>
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
